var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgrammingExplainerVideos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4297_28988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0007 3C16.8745 3 14.2486 3.16533 12.0841 3.64637C9.90068 4.13162 8.08592 4.96 6.68995 6.35597C5.29398 7.75193 4.4656 9.5667 3.98035 11.7501C3.49932 13.9146 3.33398 16.5405 3.33398 19.6667C3.33398 22.7928 3.49932 25.4187 3.98035 27.5832C4.4656 29.7667 5.29398 31.5813 6.68995 32.9773C8.08592 34.3733 9.90068 35.2017 12.0841 35.687C14.2486 36.168 16.8745 36.3333 20.0007 36.3333C23.1268 36.3333 25.7527 36.168 27.9172 35.687C30.1007 35.2017 31.9153 34.3733 33.3113 32.9773C34.7073 31.5813 35.5357 29.7667 36.021 27.5832C36.502 25.4187 36.6673 22.7928 36.6673 19.6667C36.6673 16.5405 36.502 13.9146 36.021 11.7501C35.5357 9.5667 34.7073 7.75193 33.3113 6.35597C31.9153 4.96 30.1007 4.13162 27.9172 3.64637C25.7527 3.16533 23.1268 3 20.0007 3Z",
    fill: "url(#paint0_linear_4297_28988)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4297_28988)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0007 4C16.8974 4 14.3581 4.1654 12.301 4.62255C10.2363 5.08142 8.61713 5.843 7.39706 7.06307C6.17699 8.28314 5.4154 9.90235 4.95654 11.9671C4.49939 14.0241 4.33398 16.5634 4.33398 19.6667C4.33398 22.7699 4.49939 25.3092 4.95653 27.3662L3.98035 27.5832C3.49932 25.4187 3.33398 22.7928 3.33398 19.6667C3.33398 16.5405 3.49932 13.9146 3.98035 11.7501C4.4656 9.5667 5.29398 7.75193 6.68995 6.35597C8.08592 4.96 9.90068 4.13162 12.0841 3.64637C14.2486 3.16533 16.8745 3 20.0007 3C23.1268 3 25.7527 3.16533 27.9172 3.64637L27.7002 4.62255C25.6432 4.1654 23.1039 4 20.0007 4ZM35.0448 11.9671C34.5859 9.90234 33.8243 8.28314 32.6042 7.06308C31.3841 5.843 29.765 5.08142 27.7002 4.62255L27.9172 3.64637C30.1007 4.13162 31.9153 4.96 33.3113 6.35597C34.7073 7.75193 35.5357 9.5667 36.021 11.7501C36.502 13.9146 36.6673 16.5405 36.6673 19.6667C36.6673 22.7928 36.502 25.4187 36.021 27.5832C35.5357 29.7667 34.7073 31.5813 33.3113 32.9773C31.9153 34.3733 30.1007 35.2017 27.9172 35.687C25.7527 36.168 23.1268 36.3333 20.0007 36.3333C16.8745 36.3333 14.2486 36.168 12.0841 35.687C9.90068 35.2017 8.08592 34.3733 6.68995 32.9773C5.29398 31.5813 4.4656 29.7667 3.98035 27.5832L4.95654 27.3662C5.4154 29.431 6.17698 31.0501 7.39707 32.2702C8.61713 33.4903 10.2363 34.2519 12.3011 34.7108C14.3581 35.1679 16.8974 35.3333 20.0007 35.3333C23.1039 35.3333 25.6432 35.1679 27.7002 34.7108C29.765 34.2519 31.3841 33.4903 32.6042 32.2702C33.8243 31.0501 34.5859 29.431 35.0448 27.3662C35.5019 25.3092 35.6673 22.7699 35.6673 19.6667C35.6673 16.5635 35.5019 14.0241 35.0448 11.9671Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9337 14.9392C12.2466 14.9392 12.5002 14.6859 12.5002 14.3734C12.5002 14.0609 12.2466 13.8076 11.9337 13.8076C11.6208 13.8076 11.3672 14.0609 11.3672 14.3734C11.3672 14.6859 11.6208 14.9392 11.9337 14.9392Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4356 14.9392C13.7485 14.9392 14.0021 14.6859 14.0021 14.3734C14.0021 14.0609 13.7485 13.8076 13.4356 13.8076C13.1228 13.8076 12.8691 14.0609 12.8691 14.3734C12.8691 14.6859 13.1228 14.9392 13.4356 14.9392Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9356 14.9392C15.2485 14.9392 15.5021 14.6859 15.5021 14.3734C15.5021 14.0609 15.2485 13.8076 14.9356 13.8076C14.6228 13.8076 14.3691 14.0609 14.3691 14.3734C14.3691 14.6859 14.6228 14.9392 14.9356 14.9392Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6812 13.4834L16.4863 15.3128H28.6341V13.4834H17.6812Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9688 11.1201H10.0312C9.46406 11.1201 9 11.5842 9 12.1514V27.8494C9 28.4166 9.46406 28.8806 10.0312 28.8806H29.9688C30.5359 28.8806 31 28.4166 31 27.8494V12.1514C31 11.5842 30.5359 11.1201 29.9688 11.1201ZM29.625 27.1296L28.6735 26.407H25.9393L27.3807 27.5056H26.1903L24.7437 26.4067H15.2559L13.8094 27.5053H12.619L14.0603 26.4067H11.3265L10.375 27.1292V12.4951H29.625V27.1296Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1982 18.1494L13.4414 20.2081V21.3535L18.1982 23.4222V22.0826L14.8803 20.7667L18.1982 19.4983V18.1494Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3567 17.1553L18.6387 24.3307H19.6184L21.3553 17.1553H20.3567Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7969 18.1592V19.4891L25.1192 20.7813L21.7969 22.0876V23.4271L26.5582 21.3536V20.2182L21.7969 18.1592Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4297_28988",
    x: 1.33398,
    y: 1,
    width: 37.334,
    height: 37.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4297_28988"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4297_28988",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4297_28988",
    x: 1.33398,
    y: 1,
    width: 37.334,
    height: 37.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4297_28988"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4297_28988",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4297_28988",
    x1: 20.0007,
    y1: 3,
    x2: 20.0007,
    y2: 36.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E87B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    stopColor: "#064A70"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgrammingExplainerVideos);
export default __webpack_public_path__ + "static/media/ProgrammingExplainerVideos.4bdd6670fc539ee0dee48069c8246284.svg";
export { ForwardRef as ReactComponent };